export const getExperienceData = (t) => [
  {
    id: "1",
    title: t('experienceData.salvia.title'),
    date: t('experienceData.salvia.date'),
    description: t('experienceData.salvia.description'),
  },
  {
    id: "2",
    title: t('experienceData.hedoma.title'),
    date: t('experienceData.hedoma.date'),
    description: t('experienceData.hedoma.description'),
  },
  {
    id: "3",
    title: t('experienceData.eysi.title'),
    date: t('experienceData.eysi.date'),
    description: t('experienceData.eysi.description'),
  },
];
